import { useTranslation } from 'react-i18next'

import { AnimatePresence, motion } from 'motion/react'

import { CardTitle, Divider, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const Header = ({ hideProgressBar, progressBarPercentage, onStop }) => {
  const { t } = useTranslation()

  return (
    <Styles.Header>
      <CardTitle>{t('Asistente de Inventario con IA')}</CardTitle>
      <AnimatePresence>
        {!hideProgressBar && (
          <motion.div exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.3 }}>
            <Styles.ProgressSection>
              <Text type="bodyMRegular">
                {t('Procesando recomendaciones de clasificación aduanera y datos de producto')}
              </Text>
              <Styles.ProgressBarRow>
                <Styles.ProgressBar>
                  <Styles.ProgressBarContent
                    animate={{ width: `${progressBarPercentage}%` }}
                    transition={{ duration: 0.3, delay: 0 }}
                  />
                </Styles.ProgressBar>
                <Styles.StopButton onClick={onStop}>{t('Detener')}</Styles.StopButton>
              </Styles.ProgressBarRow>
              <Divider />
            </Styles.ProgressSection>
          </motion.div>
        )}
      </AnimatePresence>
    </Styles.Header>
  )
}

export default Header
